import React from "react";
import { FaArrowRight, FaGear } from "react-icons/fa6";
import { SiWordpress, SiShopify, SiJoomla, SiDrupal, SiWebflow } from "react-icons/si";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

const platforms = [
  { icon: SiWordpress, name: "WordPress", text: "Most popular and flexible CMS for all types of websites.", cls: "text-[#21759B]" },
  { icon: SiShopify, name: "Shopify", text: "Powerful eCommerce CMS for online stores.", cls: "text-[#7AB55C]" },
  { icon: SiJoomla, name: "Joomla", text: "Robust and scalable CMS solution.", cls: "text-[#F44321]" },
  { icon: SiDrupal, name: "Drupal", text: "High-performance CMS for complex websites.", cls: "text-[#0678BE]" },
  { icon: SiWebflow, name: "Webflow", text: "Modern CMS with powerful visual design.", cls: "text-[#146EF5]" },
  { icon: FaGear, name: "Custom CMS", text: "Tailored CMS solutions as per your business needs.", cls: "text-[#334155]" },
];

const CmsPlatforms = () => (
  <section className="bg-white py-[40px] lg:py-[56px]">
    <Container className="max-w-[1320px]">
      <div className="flex flex-col gap-[16px] md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em]">
            <span className="text-[#1E5BFF]">Popular CMS </span>
            <span className="text-[#7C3AED]">Platforms</span>
          </p>
          <h2 className={`mt-[10px] font-bold tracking-tight text-[#0B1B4D] ${H2_SIZE}`}>
            We Work With Leading <span className="text-[#1E5BFF]">CMS</span> Platforms
          </h2>
          <p className="mt-[10px] max-w-[560px] text-[15px] leading-[1.6] text-slate-500">
            Choose the right platform for your business. We build websites using the most reliable and flexible CMS
            solutions.
          </p>
        </div>
        <a
          href="/#services"
          className="group inline-flex shrink-0 items-center gap-[8px] self-start border-x-0 border-b-[1.5px] border-t-0 border-solid border-[#1E4DFF] pb-[3px] text-[14.5px] font-semibold text-[#1E4DFF] md:mb-[48px] md:self-auto"
        >
          View All Services
          <FaArrowRight className="text-[12px] transition group-hover:translate-x-1" />
        </a>
      </div>

      <div className="mt-[26px] grid grid-cols-2 gap-[14px] sm:grid-cols-3 lg:grid-cols-6">
        {platforms.map((p) => (
          <div
            key={p.name}
            className="flex flex-col items-center rounded-[14px] border-[1px] border-solid border-[#EEF1F8] bg-white px-[14px] pb-[20px] pt-[22px] text-center shadow-[0_10px_28px_-20px_rgba(40,60,140,0.3)] transition hover:-translate-y-1"
          >
            <p.icon className={`text-[44px] ${p.cls}`} />
            <h3 className={`mt-[12px] font-semibold text-[#0B1B4D] ${H3_SIZE}`}>{p.name}</h3>
            <p className="mt-[6px] text-[13px] leading-[1.5] text-slate-500">{p.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default CmsPlatforms;
